
import { GetterTree } from 'vuex';
import { RootState } from '@/store';

import { State } from './state';
import { SegNotificacaoModel } from '@/models/message/seg-notificacao.model';

export type Getters = {
  getMessages(state: State, rootState: RootState, uid: string): SegNotificacaoModel[];
}

export const getters: GetterTree<State, any> & Getters = {
  getMessages: (state, rootState, uid) => state.messages as SegNotificacaoModel[]
};
